const { list: listPrograms } = require('./../../../program')
const getServiceFromPrograms = require('./../../tools/get-service-from-programs')

exports.get = function (state, serviceId) {
  return listPrograms(state, { unfiltered: true })
    .then(programs => getServiceFromPrograms(programs, serviceId))
}
